import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { Update } from "services/campaigns";
import {
  ActionButtonContainer,
  CampaingProgressContainer,
  CampaingProgressContent,
  CampaingProgressContentDescription,
  CampaingProgressContentSteps,
  CampaingProgressContentStepsContainer,
  CampaingProgressContentTimeline,
  CardAccordeonContainer,
  CardExpandContainer,
  CardExpandContainerBody,
  CardExpandContainerHeader,
  CardExpandContainerHeaderTitle,
  CardExpandContainerHeaderToggle,
  CardExpandContainerHeaderToggleItem,
  CardExpandContainerHeaderToggleItemIcon,
  CardExpandContainerHeaderToggleItemText,
  CardExpandText,
  CardExpandTitle,
  CardHomeContentBodyAction,
  IframeContainer,
  ImgContainer,
  StyledIframe,
} from "./styled";

import AssignmentIcon from '@mui/icons-material/Assignment';
import { Grid, Tooltip, Typography } from "@mui/material";
import CardAccordeon from "components/Cards/Accordeon";
import CardAssets from "components/Cards/Assets";
import CardEmpty from "components/Cards/CardEmpty";
import CardContentType from "components/Cards/ContentType";
import CreatorGaleryCard from "components/Cards/CreatorGaleryCard";
import CreatorsCardEmpty from "components/Cards/CreatorsCardEmpty";
import DashboardCampaignTab from "components/Cards/DashboardCampaignTab";
import CardGallery from "components/Cards/Gallery";
import CardKnowing from "components/Cards/Knowing";
import PostsCardEmpty from "components/Cards/PostsCardEmpty";
import CardPostsList from "components/Cards/PostsList";
import ScheduleCardEmpty from "components/Cards/ScheduleCardEmpty";
import CardScriptList from "components/Cards/ScriptAssets";
import ScriptCardEmpty from "components/Cards/ScriptCardEmpty";
import CampaingHeaderBread from "components/Dashboard/Campaing/HeaderBread";
import CampaingTabs from "components/Dashboard/Campaing/Tabs";
import Button from "components/Form/Button";
import Input from "components/Form/Input";
import ErrorToast from "components/Toasts/Error";
import SuccessToast from "components/Toasts/Success";
import ContainerAuthenticated from "containers/Authenticated";
import { CoreContext } from "context/CoreContext";
import { FeatureFlagsContext } from "context/FeatureFlagsContext";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import useCampaing from "hooks/useCampaing";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Delete } from "services/deliveries";
import { validateLink } from "services/link-validator";
import { UpdateMetricsOnDemand } from "services/post-metrics";
import { Load } from "ui/styled";
import { getFirstAndLastName } from "utils/formatString";
import { formatDatePtBr } from "utils/formatter";
import { parseCurrency } from "utils/parsers";

export default function DashboardCampaingDetails() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);
  const { isFeatureEnabled } = useContext(FeatureFlagsContext);

  const { id } = useParams();
  const location = useLocation();

  const tab = new URLSearchParams(location.search).get("view") || "briefing";

  const { currentCampaing, empty, reload, removeAsset, loading } =
    useCampaing();
  const { setModal } = useContext(CoreContext);
  const [active, setActive] = useState(tab || "briefing");
  const [deliverableActive, setDeliverableActive] = useState(1);
  const [selected, setSelected] = useState({});
  const [deliveryName, setDeliveryName] = useState("");
  const [validSchedules, setValidSchedules] = useState([{}]);

  const validateSchedules = async () => {
    const newValidSchedules = [];
    for (const key of Object.keys(currentCampaing?.schedules)) {
      const data = await validateLink({
        url: currentCampaing?.schedules[key]?.link,
      });
      const valid = data.ok;
      if (valid) {
        newValidSchedules.push(currentCampaing?.schedules[key]);
      }
      setValidSchedules(newValidSchedules);
    }
  };

  useEffect(() => {
    if (currentCampaing?.schedules) {
      validateSchedules();
    }
  }, [currentCampaing]);

  const filterDeliveryName = (item) => {
    if (!deliveryName || deliveryName === "") {
      return true;
    }

    const values = Object.values(item.file);

    return (
      values.filter(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(deliveryName.toLowerCase())
      ).length > 0
    );
  };

  const LINE_SIZE = 3;

  // const currentCampaing = useMemo(() => {
  //     return campaings?.find(f => `${f.id}` === `${id}`)
  // }, [campaings, id])

  const tabs = [
    { title: "Briefing", value: "briefing" },
    ...(isFeatureEnabled("schedule-tab-in-campaigns")
      ? [{ title: "Cronograma", value: "schedule" }]
      : []),
    { title: "Creators", value: "creators" },
    { title: "Roteiro", value: "scripts" },
    { title: "Entregáveis", value: "deliverables" },
    { title: "Publicações", value: "posts" },
    ...(isFeatureEnabled("dashboard-tab-in-campaigns")
      ? [{ title: "Dashboard", value: "dashboard" }]
      : []),
  ];

  const tomDeVoz = {
    creative: "Divertido e criativo",
    info: "Informativo",
    tech: "Técnico",
  };

  const logistica = {
    individual: "Envio individual para creator",
    lote: "Envio em lote para a Nice House distribuir entre os criadores",
    presential: "Gravação presencial em Loja/Showroom",
  };

  const deliverableTabs = [
    { title: "Lista", icon: "list" },
    { title: "Galeria", icon: "galery" },
  ];

  useEffect(() => {
    setActive(tab);
  }, [tab]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.set("view", active);

    window.history.replaceState(null, "", `?${searchParams.toString()}`);
  }, [active]);

  return (
    <>
      <ContainerAuthenticated side={1}>
        <CardHomeContentBodyAction>
          <CampaingHeaderBread
            title={currentCampaing?.title}
            bread={["Campanhas", currentCampaing?.title]}
          />

          <ActionButtonContainer>
            <ActionButton
              active={active}
              id={id}
              selected={selected}
              setSelected={setSelected}
              navigate={navigate}
              campaign={currentCampaing}
              reload={reload}
            />
          </ActionButtonContainer>
        </CardHomeContentBodyAction>

        {loading ? (
          <Load colored />
        ) : (
          <>
            <CampaingProgress campaign={currentCampaing} />

            <CampaingTabs tabs={tabs} active={active} setActive={setActive} />
            {active === "briefing" ? (
              <CardAccordeonContainer>
                <CardAccordeon
                  title={"Informações do negócio"}
                  label={currentCampaing?.label}
                >
                  <CardExpandTitle>Nome da empresa</CardExpandTitle>
                  <CardExpandText>
                    {currentCampaing?.company_company}
                  </CardExpandText>

                  <CardExpandTitle>E-mail de contato</CardExpandTitle>
                  <CardExpandText>
                    {currentCampaing?.company_email}
                  </CardExpandText>

                  <CardExpandTitle>Telefone de contato</CardExpandTitle>
                  <CardExpandText>
                    {currentCampaing?.company_phone}
                  </CardExpandText>

                  <CardExpandTitle>
                    Descreva brevemente seu produto ou marca
                  </CardExpandTitle>
                  <CardExpandText>
                    {currentCampaing?.company_brand_description}
                  </CardExpandText>
                </CardAccordeon>
                <CardAccordeon title={"Time Nice"}>
                  <CardExpandTitle>
                    Usuários responsáveis pela campanha
                  </CardExpandTitle>
                  <CardExpandText>
                    {currentCampaing?.team_nice
                      ?.map((user) => `${user.name} (${user.email})`)
                      .join(", ")}
                  </CardExpandText>
                </CardAccordeon>
                <CardAccordeon title={"Detalhes do projeto"}>
                  {currentCampaing?.campaing_type === "video-commerce" ? (
                    <>
                      <CardKnowing preview />
                    </>
                  ) : null}

                  <CardExpandTitle>Nome da campanha</CardExpandTitle>
                  <CardExpandText>{currentCampaing?.name}</CardExpandText>

                  <CardExpandTitle>Objetivo da campanha</CardExpandTitle>
                  <CardExpandText>
                    {currentCampaing?.campaing_objective}
                  </CardExpandText>

                  <CardExpandTitle>Público alvo</CardExpandTitle>
                  <CardExpandText>
                    {currentCampaing?.target_audience}
                  </CardExpandText>

                  {currentCampaing?.campaing_type === "creative-ads" ? (
                    <>
                      <CardExpandTitle>Mensagem principal</CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.main_message}
                      </CardExpandText>

                      <CardExpandTitle>
                        Expectativa de data de entrega
                      </CardExpandTitle>
                      <CardExpandText>{currentCampaing?.date}</CardExpandText>
                    </>
                  ) : null}

                  {currentCampaing?.campaing_type === "pontual-campaing" ||
                    currentCampaing?.campaing_type === "always-on" ? (
                    <>
                      <CardExpandTitle>Budget</CardExpandTitle>
                      <CardExpandText>
                        {parseCurrency(currentCampaing?.campaing_budget)}
                      </CardExpandText>

                      <CardExpandTitle>Prazo do pagamento</CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_paymentDeadline}
                      </CardExpandText>

                      <CardExpandTitle>
                        {currentCampaing?.campaing_type === "pontual-campaing"
                          ? "Expectativa de data de entrega"
                          : "Duração da campanha"}
                      </CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_type === "pontual-campaing"
                          ? formatDatePtBr(
                            currentCampaing?.expected_delivery_date
                          )
                          : `${currentCampaing?.campaing_duration} meses`}
                      </CardExpandText>

                      <CardExpandTitle>
                        Características dos criadores
                      </CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_characteristics}
                      </CardExpandText>

                      <CardExpandTitle>Tema central</CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_campaingTheme}
                      </CardExpandText>

                      <CardExpandTitle>Mensagem principal</CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.main_message}
                      </CardExpandText>

                      <CardExpandTitle>Indicadores de sucesso</CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_indicator}
                      </CardExpandText>

                      <CardExpandTitle>
                        Existe alguma restrição legal/ regulatória sobre essa
                        campanha
                      </CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_restritions}
                      </CardExpandText>

                      {!currentCampaing?.campaing_restritions_description ? null : (
                        <>
                          <CardExpandText>
                            {currentCampaing?.campaing_restritions_description}
                          </CardExpandText>
                        </>
                      )}

                      <CardExpandTitle>Do's</CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_allowed}
                      </CardExpandText>

                      <CardExpandTitle>Dont's</CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_notalloed}
                      </CardExpandText>
                    </>
                  ) : null}

                  {currentCampaing?.campaing_type === "video-commerce" ? (
                    <>
                      <CardExpandTitle>
                        Características dos criadores
                      </CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_characteristics}
                      </CardExpandText>

                      <CardExpandTitle>
                        Especificidades do(s) produto(s) que devem estar no
                        video
                      </CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_videoSpecs}
                      </CardExpandText>

                      <CardExpandTitle>Dont's</CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_notalloed}
                      </CardExpandText>

                      <CardExpandTitle>Tom de voz do video</CardExpandTitle>
                      <CardExpandText>
                        {tomDeVoz[currentCampaing?.campaing_tom]}
                      </CardExpandText>

                      <CardExpandTitle>Logística</CardExpandTitle>
                      <CardExpandText>
                        {logistica[currentCampaing?.campaing_logistic]}
                      </CardExpandText>

                      <CardAssets
                        title={"Produtos que vão ser vinculados aos vídeos"}
                        showableAssets={currentCampaing?.assets}
                        removeAsset={removeAsset}
                      />

                      <CardExpandTitle>Observações</CardExpandTitle>
                      <CardExpandText>
                        {currentCampaing?.campaing_videoObs}
                      </CardExpandText>
                    </>
                  ) : null}
                </CardAccordeon>

                <CardAccordeon title={"Detalhes do conteúdo"}>
                  <CardContentType
                    item={currentCampaing?.mood}
                    preview
                    description={currentCampaing?.other_description}
                  />
                </CardAccordeon>

                <CardAccordeon title={"Informações adicionais"}>
                  <CardExpandTitle>
                    Site de empresa / Landing page
                  </CardExpandTitle>
                  <CardExpandText link>
                    {currentCampaing?.url_site_landing_page}
                  </CardExpandText>

                  <CardExpandTitle>Call-to-action (CTA)</CardExpandTitle>
                  <CardExpandText>{currentCampaing?.cta}</CardExpandText>

                  <CardExpandTitle>Requerimento especial</CardExpandTitle>
                  <CardExpandText>
                    {currentCampaing?.special_requirement}
                  </CardExpandText>

                  <CardAssets
                    title={"Assets"}
                    showableAssets={currentCampaing?.assets}
                    removeAsset={removeAsset}
                  />
                </CardAccordeon>
              </CardAccordeonContainer>
            ) : null}

            {active === "creators" ? (
              <>
                {!currentCampaing?.creators ||
                  !Object.keys(currentCampaing?.creators).length ? (
                  <CreatorsCardEmpty
                    campaign={currentCampaing}
                    reload={reload}
                  />
                ) : (
                  <CampaingCreatorsList
                    creators={currentCampaing?.creators}
                    campaign={currentCampaing}
                    reload={reload}
                    selected={selected}
                    setSelected={setSelected}
                  />
                )}
              </>
            ) : null}

            {active === "scripts" ? (
              <>
                {!currentCampaing?.scripts ||
                  !Object.keys(currentCampaing.scripts).length ? (
                  <ScriptCardEmpty campaign={currentCampaing} reload={reload} />
                ) : (
                  <CardScriptList
                    campaign={currentCampaing}
                    scripts={currentCampaing?.scripts}
                    reload={reload}
                  />
                )}
              </>
            ) : null}

            {active === "deliverables" ? (
              <>
                {!empty ? null : (
                  <CardEmpty campaign={currentCampaing} reload={reload} />
                )}
                {empty ? null : (
                  <>
                    <div
                      style={{
                        background: "rgba(255, 255, 255, 1)",
                        borderRadius: "100px",
                        maxWidth: "620px",
                      }}
                    >
                      <Input
                        withSearch
                        rounded
                        placeholder="Buscar entregável"
                        value={deliveryName}
                        onChange={(e) => setDeliveryName(e.target.value)}
                      />
                    </div>
                    <CardExpandContainer>
                      <CardExpandContainerHeader>
                        <CardExpandContainerHeaderTitle>
                          Entregáveis da NiceHouse
                        </CardExpandContainerHeaderTitle>

                        <CardExpandContainerHeaderToggle>
                          {deliverableTabs?.map((item, key) => (
                            <CardExpandContainerHeaderToggleItem
                              key={key}
                              active={deliverableActive === key}
                              onClick={() => setDeliverableActive(key)}
                            >
                              <CardExpandContainerHeaderToggleItemIcon
                                active={deliverableActive === key}
                                icon={item?.icon}
                              />
                              <CardExpandContainerHeaderToggleItemText
                                active={deliverableActive === key}
                              >
                                {item?.title}
                              </CardExpandContainerHeaderToggleItemText>
                            </CardExpandContainerHeaderToggleItem>
                          ))}
                        </CardExpandContainerHeaderToggle>
                      </CardExpandContainerHeader>

                      <CardExpandContainerBody>
                        {deliverableActive === 0 ? (
                          <CardAssets
                            campaign={currentCampaing}
                            showableAssets={currentCampaing?.deliveries.filter(
                              filterDeliveryName
                            )}
                            removable={true}
                            removeAsset={async (id) => await Delete(id)}
                            showModal
                            reload={reload}
                            toReview={true}
                          />
                        ) : null}
                        {deliverableActive === 1 ? (
                          <Grid container spacing={2}>
                            {currentCampaing?.deliveries
                              ?.filter(filterDeliveryName)
                              ?.map((item, key) => (
                                <Grid
                                  item
                                  size={{
                                    sm: 12,
                                    md: 6,
                                    lg: 4,
                                  }}
                                  key={`${key}`}
                                >
                                  <CardGallery
                                    campaign={currentCampaing}
                                    item={item}
                                    reload={reload}
                                    removeAsset={async (id) => await Delete(id)}
                                  />
                                </Grid>
                              ))}
                          </Grid>
                        ) : null}
                      </CardExpandContainerBody>
                    </CardExpandContainer>
                  </>
                )}
              </>
            ) : null}

            {active === "schedule" ? (
              !currentCampaing?.schedules ||
                !Object.keys(currentCampaing?.schedules).length ? (
                <ScheduleCardEmpty campaign={currentCampaing} reload={reload} />
              ) : validSchedules.length !=
                Object.keys(currentCampaing?.schedules).length ? (
                <ScheduleCardEmpty
                  campaign={currentCampaing}
                  reload={reload}
                  title={"Cronograma Inválido"}
                  description={"Confira o link do cronograma"}
                  buttonText={"VERIFICAR CRONOGRAMA"}
                  error={true}
                />
              ) : (
                validSchedules.map((schedule) => (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                    key={schedule.id}
                  >
                    <IframeContainer>
                      <StyledIframe
                        z-index="0"
                        width="100%"
                        height="100vh"
                        src={schedule?.link}
                        allow="accelerometer; autoplay"
                        referrerpolicy="strict-origin-when-cross-origin"
                      />
                    </IframeContainer>
                    <Tooltip title={schedule?.createBy?.name || " "}>
                      <Typography
                        display={{ xs: "none", md: "block" }}
                        style={{
                          margin: 0,
                          fontSize: "16",
                          marginLeft: "5px",
                          marginBottom: "8px",
                        }}
                      >
                        Enviado em:{" "}
                        {moment(schedule?.createdAt).format("DD/MM/YYYY")} às{" "}
                        {moment(schedule?.createdAt).format("HH:mm")}, por{" "}
                        {getFirstAndLastName(schedule?.createBy?.name) || " "}
                      </Typography>
                    </Tooltip>
                  </div>
                ))
              )
            ) : null}

            {active === "posts" ? (
              <>
                {!currentCampaing?.posts ||
                  !Object.keys(currentCampaing.posts).length ? (
                  <PostsCardEmpty campaign={currentCampaing} reload={reload} />
                ) : (
                  <CardPostsList
                    campaign={currentCampaing}
                    posts={currentCampaing?.posts}
                    reload={reload}
                  />
                )}
              </>
            ) : null}

            {active === "dashboard" ? <DashboardCampaignTab /> : null}
          </>
        )}
      </ContainerAuthenticated>
    </>
  );
}

function ActionButton({
  active,
  id,
  navigate,
  campaign,
  reload,
  selected,
  setSelected,
}) {
  const { setModal } = useContext(CoreContext);
  const { removeSchedule } = useCampaing();
  const [updatingMetrics, setUpdatingMetrics] = useState(false);

  const handleUpdateMetricsOnDemand = async () => {
    try {
      setUpdatingMetrics(true);
      await UpdateMetricsOnDemand(campaign?.id);
      SuccessToast({ message: "Métricas atualizadas com sucesso" });
      reload();
    } catch (error) {
      ErrorToast({ message: "Erro ao atualizar métricas" });
    } finally {
      setUpdatingMetrics(false);
    }
  };

  if (active === "briefing" && campaign) {
    return (
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <AssignmentIcon
          onClick={() =>
            setModal({
              type: "campaign-status-logs",
              item: {
                campaign,
              },
              reload,
            })
          }
          sx={{ marginTop: "14px", fontSize: "35px", cursor: "pointer" }}
        />
        <Button
          onClick={() =>
            setModal({
              type:
                campaign?.status !== "finished"
                  ? "finish-campaign"
                  : "restart-campaign",
              item: {
                campaign,
              },
              reload,
            })
          }
          primary
          sx={{ padding: "0px 40px 0px 40px", whiteSpace: "nowrap" }}
        >
          {campaign?.status !== "finished"
            ? "FINALIZAR CAMPANHA"
            : "REINICIAR CAMPANHA"}
        </Button>
        {campaign?.status === "progress" && (
          <Button
            onClick={() => navigate(`dashboard/campaing/edit/${id}`)}
            primary
          >
            EDITAR CAMPANHA
          </Button>
        )}
      </div>
    );
  }

  if (
    active === "creators" &&
    campaign?.creators &&
    Object.keys(campaign.creators).length &&
    !Object.keys(selected).length
    && campaign?.status !== "finished"
  ) {
    return (
      <Button
        primary
        nospace
        onClick={() => setModal({ type: "creators", item: campaign, reload })}
      >
        ADICIONAR CREATORS
      </Button>
    );
  }
  if (
    active === "creators" &&
    campaign?.creators &&
    Object.keys(campaign.creators).length &&
    Object.keys(selected).length
    && campaign?.status !== "finished"
  ) {
    return (
      <Button
        onClick={async () => {
          const notSelected = Object.values(campaign.creators).filter(
            (c) => !selected[c.id]
          );
          const list = Object.entries(selected).map(([key, value]) => ({
            ...value,
            id: key,
          }));

          await Update(
            { data: { creators: [...notSelected, ...list] } },
            campaign.id
          );

          SuccessToast({ message: "Creators adicionados" });

          reload();
          setSelected({});
        }}
        primary
      >
        SELECIONAR CREATORS
      </Button>
    );
  }

  if (
    active === "scripts" &&
    campaign?.scripts &&
    Object.keys(campaign.scripts).length
    && campaign?.status !== "finished"
  ) {
    return (
      <Button
        primary
        nospace
        onClick={() => setModal({ type: "add-script", item: campaign, reload })}
      >
        IMPORTAR ROTEIROS
      </Button>
    );
  }

  if (
    active === "schedule" &&
    campaign?.schedules &&
    Object.keys(campaign.schedules)?.length
    && campaign?.status !== "finished"
  ) {
    return (
      <>
        <div>
          <Button
            primary
            nospace
            onClick={() => {
              setModal({
                type: "delete",
                item: {
                  description: "Remover cronograma?",
                  onClick: () => {
                    removeSchedule(campaign?.id);
                    reload();
                  },
                },
              });
            }}
          >
            REMOVER CRONOGRAMA
          </Button>
        </div>
        <div>
          <Button
            primary
            nospace
            onClick={() =>
              setModal({
                type: "add-schedule",
                item: { ...campaign, type: "edit" },
                reload,
              })
            }
          >
            EDITAR CRONOGRAMA
          </Button>
        </div>
      </>
    );
  }

  if (active === "deliverables" && campaign?.deliveries?.length && campaign?.status !== "finished") {
    return (
      <Button
        primary
        nospace
        onClick={() =>
          setModal({ type: "add-delivery", item: campaign, reload })
        }
      >
        IMPORTAR ENTREGÁVEIS
      </Button>
    );
  }

  if (
    active === "posts" &&
    campaign?.posts &&
    Object.keys(campaign.posts).length
    && campaign?.status !== "finished"
  ) {
    return (
      <Button
        primary
        nospace
        onClick={() => setModal({ type: "posts", item: campaign, reload })}
      >
        ADICIONAR PUBLICAÇÕES
      </Button>
    );
  }

  if (
    active === "dashboard" &&
    campaign?.posts &&
    Object.keys(campaign.posts).length
    && campaign?.status !== "finished"
  ) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
        }}
      >
        <Button
          primary
          nospace
          onClick={handleUpdateMetricsOnDemand}
          loading={updatingMetrics}
          sx={{ width: 208 }}
        >
          ATUALIZAR MÉTRICAS
        </Button>
        {campaign.lastMetricsUpdate && (
          <p
            style={{
              position: "absolute",
              fontSize: 11,
              bottom: -25,
              width: "100%",
              textAlign: "center",

              margin: 0,
            }}
          >
            Última atualização:{" "}
            {format(campaign.lastMetricsUpdate, "dd/MM/yyyy HH:mm", {
              locale: ptBR,
            })}
          </p>
        )}
      </div>
    );
  }

  return null;
}

function CampaingProgress({ campaign }) {
  const { isFeatureEnabled } = useContext(FeatureFlagsContext);

  return (
    <CampaingProgressContainer
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#FFFFFF",
        padding: "16px",
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px",
        margin: "16px 0px 0px",
      }}
    >
      <ImgContainer style={{ display: "flex" }}>
        <div
          style={{
            background:
              "linear-gradient(95.57deg, #FAC7FF -3.94%, rgba(55, 243, 255, 0) 161.66%)",
            width: "108.85px",
            height: "103.92px",
            gap: "0px",
            opacity: "0px",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img src="/images/calendar.png"></img>
        </div>
      </ImgContainer>

      <CampaingProgressContent>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          <h6 style={{ fontSize: "16px" }}>Linha do tempo</h6>
          <CampaingProgressContentDescription
            style={{ fontSize: "14px", width: 380, marginBottom: 0 }}
          >
            Essas são as etapas que precisamos seguir para conseguir garantir a
            entrega dos seus materiais para o cliente.
          </CampaingProgressContentDescription>
        </div>
        <CampaingProgressContentStepsContainer
          style={{
            display: "flex",
            position: "relative",
            height: "51px",
          }}
        >
          <CampaingProgressContentSteps
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "0px",
              marginBottom: "0px",
              zIndex: "2",
            }}
          >
            <img
              src="/images/check-purple.png"
              width="24px"
              height="24px"
            ></img>
            <p style={{ fontSize: "12px", marginTop: "8px", marginBottom: 0 }}>
              Briefing
            </p>
          </CampaingProgressContentSteps>
          {isFeatureEnabled("schedule-tab-in-campaigns") && (
            <CampaingProgressContentSteps
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "0px",
                marginBottom: "0px",
                zIndex: "2",
              }}
            >
              <img
                src={
                  campaign &&
                    campaign?.schedules &&
                    Object.keys(campaign?.schedules).length
                    ? "/images/check-purple.png"
                    : "/images/empty-check.png"
                }
                width="24px"
                height="24px"
              ></img>
              <p
                style={{ fontSize: "12px", marginTop: "8px", marginBottom: 0 }}
              >
                Cronograma
              </p>
            </CampaingProgressContentSteps>
          )}
          <CampaingProgressContentSteps
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "0px",
              marginBottom: "0px",
              zIndex: "2",
            }}
          >
            <img
              src={
                campaign &&
                  campaign.creators &&
                  Object.keys(campaign.creators).length
                  ? "/images/check-purple.png"
                  : "/images/empty-check.png"
              }
            ></img>
            <p style={{ fontSize: "12px", marginTop: "8px", marginBottom: 0 }}>
              Creators
            </p>
          </CampaingProgressContentSteps>

          <CampaingProgressContentSteps
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "0px",
              marginBottom: "0px",
              zIndex: "2",
            }}
          >
            <img
              src={
                campaign &&
                  campaign?.scripts &&
                  Object.keys(campaign.scripts).length
                  ? "/images/check-purple.png"
                  : "/images/empty-check.png"
              }
            ></img>
            <p style={{ fontSize: "12px", marginTop: "8px", marginBottom: 0 }}>
              Roteiro
            </p>
          </CampaingProgressContentSteps>

          <CampaingProgressContentSteps
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "0px",
              marginBottom: "0px",
              zIndex: "2",
            }}
          >
            <img
              src={
                campaign &&
                  campaign?.deliveries &&
                  Object.keys(campaign?.deliveries).length
                  ? "/images/check-purple.png"
                  : "/images/empty-check.png"
              }
            ></img>
            <p style={{ fontSize: "12px", marginTop: "8px", marginBottom: 0 }}>
              Entregáveis
            </p>
          </CampaingProgressContentSteps>

          <CampaingProgressContentSteps
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "0px",
              marginBottom: "0px",
              zIndex: "2",
            }}
          >
            <img
              src={
                campaign && campaign.posts && Object.keys(campaign.posts).length
                  ? "/images/check-purple.png"
                  : "/images/empty-check.png"
              }
            ></img>
            <p style={{ fontSize: "12px", marginTop: "8px", marginBottom: 0 }}>
              Publicações
            </p>
          </CampaingProgressContentSteps>
          <CampaingProgressContentTimeline
            src="/images/timeline-line.png"
            width="100%"
            height="5px"
            style={{
              position: "absolute",
              zIndex: "1",
              marginTop: "10px",
            }}
          ></CampaingProgressContentTimeline>
        </CampaingProgressContentStepsContainer>
      </CampaingProgressContent>
    </CampaingProgressContainer>
  );
}

function CampaingCreatorsList({
  creators,
  campaign,
  reload,
  selected,
  setSelected,
}) {
  const [creatorName, setCreatorName] = useState();
  const { user } = useContext(CoreContext);
  const hasApproved = Object.values(creators).filter((c) => c.approved).length;
  const selectedCount = Object.keys(selected).length;
  const hasCreatorsToSeled = Object.values(creators).filter(
    (c) => !c.approved
  ).length;
  const toggleSelection = (item) => {
    setSelected((prevSelected) => {
      const newSelected = { ...prevSelected };
      if (newSelected[item.id]) {
        delete newSelected[item.id];
      } else {
        newSelected[item.id] = {
          ...item,
          approved: true,
          approvedBy: user,
          approvedAt: new Date(),
        };
      }
      return newSelected;
    });
  };

  const selectAll = () => {
    const allSelected =
      Object.keys(selected).length ===
      Object.values(creators).filter((c) => !c.approved).length;
    if (!allSelected) {
      Object.values(creators).forEach((item) => {
        if (!selected[item.id] && !item.approved) {
          toggleSelection(item);
        }
      });
    }
  };

  const deselectAll = () => {
    setSelected({});
  };

  const filterName = (item) => {
    if (!creatorName || creatorName === "") {
      return true;
    }

    return (
      Object.values(item).filter(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(creatorName.toLowerCase())
      ).length > 0
    );
  };

  return (
    <>
      <div
        style={{
          background: "rgba(255, 255, 255, 1)",
          borderRadius: "100px",
          maxWidth: "620px",
        }}
      >
        <Input
          withSearch
          rounded
          placeholder="Buscar creator"
          value={creatorName}
          onChange={(e) => setCreatorName(e.target.value)}
        />
      </div>
      {hasCreatorsToSeled > 0 && (
        <>
          <Typography
            sx={{
              marginTop: "16px",
              fontSize: "24px",
              marginBottom: "16px",
            }}
          >
            Creators disponíveis
          </Typography>
          <div
            style={{
              display: "flex",
              borderRadius: "8px",
              padding: "24px",
              boxShadow: "0px 0px 16px 0px rgba(0, 0, 0, 0.16)",
              alignItems: "center",
              background: "#FFF",
            }}
          >
            <img src="/images/check-purple-white.png" width="40" height="40" />
            <div style={{ marginLeft: "16px" }}>
              <Typography
                variant="h6"
                sx={{ fontSize: "14px", marginBottom: "4px" }}
              >
                Selecione creators
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "12px", margin: 0 }}>
                Faça a seleção dos creators que você gostaria de ver criando
                conteúdos incríveis para a sua marca.
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "auto",
                cursor: "pointer",
              }}
              onClick={selectAll}
            >
              <Typography
                variant="h6"
                sx={{ fontSize: "14px", marginBottom: "4px", color: "#5339E3" }}
              >
                Selecionar tudo
              </Typography>
            </div>
          </div>
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontSize: "14px", marginBottom: "4px" }}
            >
              <span style={{ fontWeight: "bold" }}>{selectedCount}</span> itens{" "}
              <span style={{ fontWeight: "bold" }}>selecionados</span>
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "auto",
                cursor: `${selectedCount > 0 ? "pointer" : ""}`,
                marginBottom: "4px",
              }}
              onClick={deselectAll}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: "14px",
                  color: `${selectedCount > 0 ? "#5339E3" : ""}`,
                }}
              >
                Limpar seleção
              </Typography>
            </div>
          </div>
          <Grid
            container
            columnSpacing={2}
            sx={{
              marginTop: "0px",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {Object.values(creators)
              .filter(filterName)
              .filter((c) => !c.approved)
              .map((item) => (
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                  key={item.id}
                >
                  <CreatorGaleryCard
                    influencer={item}
                    clickable
                    selected={selected[item.id]}
                    creators={creators}
                    campaign={campaign}
                    reload={reload}
                    onClick={() => toggleSelection(item)}
                  />
                </Grid>
              ))}
          </Grid>
        </>
      )}
      {hasApproved ? (
        <>
          <Typography
            sx={{
              fontSize: "24px",
              marginTop: "16px",
            }}
          >
            Creators selecionados
          </Typography>

          <Grid
            container
            columnSpacing={2}
            sx={{
              marginTop: "0px",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {Object.values(creators)
              .filter(filterName)
              .filter((c) => c.approved)
              .map((item) => (
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                  key={item.id}
                >
                  <CreatorGaleryCard
                    influencer={item}
                    canBeSelected={false}
                    selected={selected[item.id]}
                    creators={creators}
                    campaign={campaign}
                    reload={reload}
                  />
                </Grid>
              ))}
          </Grid>
        </>
      ) : null}
    </>
  );
}